export const safeWindow = typeof window !== 'undefined' ? window : undefined;
